import { Model as t } from "../../../../model.js";
class c extends t {
  constructor(e) {
    super(), this.shopTicket = e.shopTicket, this.ticket = e.ticket, this.checkoutFields = e.checkoutFields;
  }
}
export {
  c as ShopSessionCheckoutModel
};
//# sourceMappingURL=checkout.model.js.map
